import React from "react";


const Loader = React.memo(() => {
    return(
        <div className={"loader"}>
        </div>
    )
})

export default Loader